/**
 * OverlayNavnsuperLowerThird - Name/title lower third with blue/gold broadcast theme
 */

import { TravparkLogo } from './TravparkLogo';

export function OverlayNavnsuperLowerThird({
  navnsuperVisible, showNavnsuper, navnsuperData, colors, sommertravetMode
}) {
  if (!navnsuperVisible) return null;

  return (
    <div
      data-testid="navnsuper-lower-third"
      className={showNavnsuper && navnsuperData ? 'broadcast-scale-up' : 'broadcast-scale-down'}
      style={{
        position: 'absolute',
        bottom: '85px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '12px 12px 0 0',
        backgroundColor: '#050F23',
        border: '2px solid var(--theme-panel-border-subtle)',
        padding: '0',
        minWidth: '400px',
        maxWidth: '600px',
        boxShadow: `0 0 30px rgba(var(--theme-accent-rgb), 0.15), 0 15px 45px rgba(0,0,0,0.5)`,
        overflow: 'hidden',
        zIndex: 1,
        isolation: 'isolate',
      }}
    >

      {navnsuperData && (
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            background: 'linear-gradient(135deg, var(--theme-header-gradient) 0%, transparent 100%)',
            borderBottom: navnsuperData.title ? '2px solid var(--theme-panel-border)' : 'none',
            color: '#FFFFFF',
            padding: '0 40px', display: 'flex', alignItems: 'center',
            justifyContent: 'center', gap: '16px', height: '90px', overflow: 'hidden',
          }}>
            <TravparkLogo height={82} sommertravetMode={sommertravetMode} style={{ flexShrink: 0 }} />
            <div style={{
              fontFamily: "'Barlow Condensed', sans-serif", fontSize: '2.5rem',
              fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.02em',
              color: 'var(--theme-accent)',
            }}>
              {navnsuperData.name}
            </div>
          </div>
          {navnsuperData.title && (
            <div style={{ color: '#FFFFFF', padding: '16px 40px', textAlign: 'center', background: 'rgba(255,255,255,0.03)' }}>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1.6rem', fontWeight: 500 }}>
                {navnsuperData.title}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
